import React from 'react';
import { usePress } from '@react-aria/interactions';
export const IconButton = (props) => {
    const { pressProps } = usePress({ onPress: props.onPress });
    return (React.createElement("div", Object.assign({ style: { display: 'flex' } }, pressProps), props.children));
};
